import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { corporateTheme } from '../themes/corporate';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: ${corporateTheme.backgroundGradient};
  padding: 120px 2rem 4rem;
  font-family: ${corporateTheme.fontFamily};
`;

const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
`;

const Title = styled(motion.h1)`
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 700;
  color: ${corporateTheme.textPrimary};
  margin-bottom: 2rem;
  text-align: center;
`;

const Content = styled(motion.div)`
  background: ${corporateTheme.cardBackground};
  border-radius: 20px;
  padding: 3rem;
  box-shadow: ${corporateTheme.cardShadow};
  border: 1px solid ${corporateTheme.cardBorder};
  margin-bottom: 2rem;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  color: ${corporateTheme.primary};
  margin-bottom: 1rem;
  font-weight: 600;
`;

const Text = styled.p`
  color: ${corporateTheme.textSecondary};
  line-height: 1.7;
  margin-bottom: 1rem;
  font-size: 1.1rem;
`;

const CompanyInfo = styled.div`
  background: rgba(30, 64, 175, 0.05);
  border-radius: 15px;
  padding: 2rem;
  border: 1px solid rgba(30, 64, 175, 0.2);
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const InfoCard = styled.div`
  background: ${corporateTheme.cardBackground};
  border-radius: 15px;
  padding: 2rem;
  text-align: center;
  border: 1px solid ${corporateTheme.cardBorder};
`;

const InfoTitle = styled.h3`
  color: ${corporateTheme.primary};
  font-size: 1.2rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const InfoText = styled.p`
  color: ${corporateTheme.textSecondary};
  line-height: 1.6;
`;

const AboutUs = () => {
  return (
    <PageContainer>
      <Container>
        <Title
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          About GrowTech
        </Title>
        
        <Content
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Section>
            <SectionTitle>Our Mission</SectionTitle>
            <Text>
              GrowTech Ltd is a leading digital affiliate marketing platform specializing in Eastern Asian markets. 
              We connect high-quality advertisers with performance-driven affiliates, creating mutually beneficial 
              partnerships that drive sustainable growth.
            </Text>
            <Text>
              Our mission is to revolutionize affiliate marketing in Eastern Asia by providing cutting-edge technology, 
              transparent reporting, and dedicated support to help our partners achieve their business goals.
            </Text>
          </Section>

          <Section>
            <SectionTitle>What We Do</SectionTitle>
            <Text>
              We specialize in e-commerce, SaaS, and digital service affiliate programs, offering:
            </Text>
            <Text>
              • High-converting affiliate campaigns across multiple verticals<br/>
              • Advanced tracking and analytics platform<br/>
              • Dedicated account management and support<br/>
              • Competitive commission structures<br/>
              • Real-time reporting and payments
            </Text>
          </Section>

          <Section>
            <SectionTitle>Our Advantage</SectionTitle>
            <Text>
              With deep understanding of Eastern Asian markets and consumer behavior, we provide localized solutions 
              that deliver results. Our proprietary technology platform ensures accurate tracking, fraud prevention, 
              and optimal performance for all partners.
            </Text>
          </Section>
        </Content>

        <CompanyInfo>
          <SectionTitle style={{ textAlign: 'center', marginBottom: '2rem' }}>
            Company Information
          </SectionTitle>
          
          <InfoGrid>
            <InfoCard>
              <InfoTitle>Legal Entity</InfoTitle>
              <InfoText>GrowTech Ltd</InfoText>
            </InfoCard>
            
            <InfoCard>
              <InfoTitle>Headquarters</InfoTitle>
              <InfoText>Hong Kong</InfoText>
            </InfoCard>
            
            <InfoCard>
              <InfoTitle>Email</InfoTitle>
              <InfoText>info@growtech.cc</InfoText>
            </InfoCard>
            
            <InfoCard>
              <InfoTitle>Business Focus</InfoTitle>
              <InfoText>Digital Affiliate Marketing<br/>Eastern Asian Markets</InfoText>
            </InfoCard>
          </InfoGrid>
        </CompanyInfo>
      </Container>
    </PageContainer>
  );
};

export default AboutUs; 